import React from 'react';
import { StyleSheet, View } from 'react-native';

import { SPACING } from '@garnish/constants';
import { useBreakpointHelpers } from '../../../hooks';
import { ButtonZoom, ButtonCenterLocation } from '../../Button';
import type { MapControlsProps } from '../types';

// ────────────────────────────────────────────────────────────────────────────────

export const MapControls = (props: MapControlsProps) => {
  const {
    onZoomInPress,
    onZoomOutPress,
    onGeolocateUserBtnPress,
    disableGeolocateUserBtn,
    zoomInAccessibilityLabel,
    zoomInAccessibilityHint,
    zoomOutAccessibilityLabel,
    zoomOutAccessibilityHint,
    centerLocationAccessibilityLabel,
    centerLocationAccessibilityHint,
  } = props;
  const { currentBreakpoint } = useBreakpointHelpers();

  // ─────────────────────────────────────────────────────────────────

  const mapControlsStyles = [
    styles.wrapper,
    currentBreakpoint.isMobile ? styles.wrapperMobile : styles.wrapperTablet,
  ];

  // ─────────────────────────────────────────────────────────────────

  return (
    <View style={mapControlsStyles} testID="map-controls-wrapper">
      {onGeolocateUserBtnPress ? (
        <ButtonCenterLocation
          onPress={onGeolocateUserBtnPress}
          disabled={disableGeolocateUserBtn}
          style={styles.buttonMapFAB}
          accessibilityLabel={centerLocationAccessibilityLabel}
          accessibilityHint={centerLocationAccessibilityHint}
        />
      ) : null}

      {onZoomInPress && onZoomOutPress && !currentBreakpoint.isMobile ? (
        <ButtonZoom
          zoomInProps={{
            onPress: onZoomInPress,
            accessibilityLabel: zoomInAccessibilityLabel,
            accessibilityHint: zoomInAccessibilityHint,
          }}
          zoomOutProps={{
            onPress: onZoomOutPress,
            accessibilityLabel: zoomOutAccessibilityLabel,
            accessibilityHint: zoomOutAccessibilityHint,
          }}
        />
      ) : null}
    </View>
  );
};

//
// ─── STYLES ─────────────────────────────────────────────────────────────────────
//

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    zIndex: 1,
  },
  wrapperMobile: {
    top: SPACING.medium,
    right: SPACING.medium,
  },
  wrapperTablet: {
    right: SPACING.xlarge,
    bottom: SPACING.large,
  },
  buttonMapFAB: {
    marginBottom: 16,
  },
});
